// npm packages
import { Container, Row, Col, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// project imports
import { CardEffect } from "./CardEffect/CardEffect";

// assets
import { ArrowDownCircle } from "react-bootstrap-icons";
import me from "../assets/img/me/foto8.jpg";

// config
import { websites } from "../config/contact";

import "animate.css";

import "./Banner.css"

export const Banner = () => {
  const { t } = useTranslation();

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="aligh-items-center justify-content-center gap-0 gap-sm-5">
        <Col xs={12} md={6}>
            <div className="animate__animated animate__fadeIn">
              <h1>
                {t("banner.greeting")} <br />
                {t("banner.iam")} <br />
                <span className="wrap">{t("banner.name")}</span>.
              </h1>
              <p>
                {t("banner.description")}
              </p>

              <div className="social-container d-flex gap-2">
                {websites.map((item, i) => (
                  <Nav.Item key={i}>
                    <Nav.Link
                      className="square-button"
                      href={item.url}
                      target="_blank"
                    >
                      {item.icon}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </div>
              <button className="banner__button">
                <a href="#about" className="button-link">
                  {t("banner.keepViewing")}
                  <ArrowDownCircle className="banner_button-svg" size={25} />
                </a>
              </button>
            </div>
          </Col>
          <Col xs={12} md={3}>
          <div className="animate__animated animate__zoomIn d-flex justify-content-md-end card-container">
              <CardEffect image={me} text={t("banner.contactMe")} isLink={true} className="m-auto m-lg-0" />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
